export const tipoTarefaEnum = {
    COMUM: 1,
    PARCELADA: 2,
    ENCADEADA: 3,
    AVULSA: 4,
    AVULSAENCADEADA: 5
}